import { styled, Paper, colors } from '@mui/material';

export const PaperFrameStyled = styled(Paper)(({ theme }) => ({
  boxShadow: `
  0px 3px 5px -1px #CDCDCD33,
  0px 5px 8px 0px #CDCDCD24,
  0px 1px 14px 0px #CDCDCD1F
`,
  border: `0.5px solid ${colors.grey[200]}`,
  overflow: 'hidden',

  [theme.breakpoints.up('sm')]: {
    borderRadius: 16,
  },

  [theme.breakpoints.down('sm')]: {
    borderRadius: 0,
  },
}));
